import { usePetitionDetailsPageData } from 'src/app/pages/petitionGamma/details/pageContext';

type Result = ModelHookResult<{
	isSunriseDescriptionEnabled: boolean;
	isSunriseHeadingEnabled: boolean;
	isSunriseSupportersEnabled: boolean;
	isSunriseRecentSigners: boolean;
}>;

export const useIsFullSunriseEnabled = (): Result => {
	const {
		data: {
			featureConfigs: { petitionPageFullSunrise },
		},
	} = usePetitionDetailsPageData();

	/* We will use the FC to determine if full sunrise is enabled for a given module.
	 * In case a module is being experimented on, we will only fetch the experiment, no need for the FC since
	 * the experiment will use the FC under the hood.
	 */
	const { petitionDescription, petitionHeading, supporters, recentSigners } = petitionPageFullSunrise;

	return {
		data: {
			isSunriseDescriptionEnabled: !!petitionDescription?.enabled,
			isSunriseHeadingEnabled: !!petitionHeading?.enabled,
			isSunriseSupportersEnabled: !!supporters?.enabled,
			isSunriseRecentSigners: !!recentSigners?.enabled,
		},
	};
};
